

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const purchaseReceiveMasterData = atom({key:'purchaseReceiveMasterData', default:{}});
const addPurchaseReceiveAtom = atom({key:'purchaseReceiveEdit', default:{ list:[]}});



export  const SetPurchaseReceiveListData = () => useSetRecoilState(purchaseReceiveMasterData);
export  const GetPurchaseReceiveListData = () => useRecoilValue(purchaseReceiveMasterData);


export  const SetAddPurchaseReceive = () => useSetRecoilState(addPurchaseReceiveAtom);
export  const GetAddPurchaseReceive = () => useRecoilValue(addPurchaseReceiveAtom);
export const ResetAddPurchaseReceive = ()=> useResetRecoilState(addPurchaseReceiveAtom);





